import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import axios from 'axios'
import {
  setNotifContract,
  setNotifOrder,
  setNotifSalesOrder,
  setNotifSIP,
  setNotifNego,
  setNotifFindoc,
  setNotifFindocApp,
  setNotifFindocRej,
  setNotifFindocRev,
  setNotifOrderCus,
  setNotifOrderSalesPI,
  setNotifOrderRevisi,
  setNotifOrderReject,
  setNotifOrderSelesai,
  setNotifContractOto,
  setNotifSIPOto,
  setNotifSalesOrderOto,
  setNotifSIPSA,
  setNotifApprovalSA,
  setNotifContractSA,
  setNotifSalesOrderSA,
  setNotifOrderSalesAdmin,
  setNotifFindocFinance,
  setNotifNonSales,
  setNotifAmandemenContract,
  setNotifAmandemenOrder,
  setNotifFindocSent,
  setNotifSIProcess,
  setNotifSIAmend,
  setNotifSITotal,
} from '../../redux/content'

import {checkToken} from '../../../api/modules/auth'

export default function Notification({children}: any) {
  const dispath = useDispatch()
  const [credential, setCredential] = useState(localStorage.getItem('credential'))
  // const [role, setRole] = useState<any>(localStorage.getItem('role-flag'))
  const [role, setRole] = useState<any>(localStorage.getItem('role_flagg'))
  const token = localStorage.getItem('token')
  const getNotif = useSelector((state: any) => state.notif.getNotif)
  const [asseccesses, setAsseccesses] = useState<any>(JSON.parse(localStorage.getItem('accesses')!))
  const notifNonSales = useSelector((state: any) => state.notif.notifNonSales)

  //Otorisator
  const getNotifOtorisator = async () => {
    function finding(access: any) {
      return access.menu.uri == 'approval'
    }

    await Promise.all(
      JSON.parse(localStorage.getItem('accesses')!)
        ?.role_accesses?.find(finding)
        ?.menu?.sub_menu?.map(async (item: any) => {
          if (item?.uri == 'approval/contract') {
            const res = await axios.get(
              `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract/get-otorisator?credentials=${credential}&status_notif=true`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            dispath(setNotifContractOto(res.data.data))
          } else if (item?.uri == 'approval/sales-order') {
            await new Promise((resolve) => {
              setTimeout(() => {
                resolve('')
              }, 2000)
            })
            const res = await axios.get(
              `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order/get-otorisator?credentials=${credential}&status_notif=true`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            dispath(setNotifSalesOrderOto(res.data.data))
          } else if (item?.uri == 'approval/sip') {
            await new Promise((resolve) => {
              setTimeout(() => {
                resolve('')
              }, 2000)
            })
            const res = await axios.get(
              `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sip_order/get-otorisator?credentials=${credential}&status_notif=true`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            dispath(setNotifSIPOto(res.data.data))
          }
          return ''
        })
    )

    // const res = await axios.get(
    //   `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/notification/approvals?credentials=${credential}&role=otorisator`
    // )

    // dispath(setNotifContractOto(res.data.data.contract))
    // dispath(setNotifSIPOto(res.data.data.sip))
    // dispath(setNotifSalesOrderOto(res.data.data.sales_order))
  }

  // Admin
  // const getNotifAdmin = async () => {
  //   const res = await axios.get(
  //     `http://34.128.85.104/management/api/order-submission/all?credentials=${credential}&status_notif=0`
  //   )
  //   // console.log(res, 'ini res')

  //   dispath(setNotifOrder(res.data.data))
  // }

  // Sales Admin
  const getNotifOrderSalesAdmin = async () => {
    const data = {status_notif: [0, 5, 90]}
    const res = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/order-submission/all?credentials=${credential}&regarding=PO001`,
      {
        params: data,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    // console.log(res, 'ini res')

    dispath(setNotifOrderSalesAdmin(res.data.data.total))
    dispath(setNotifOrderSalesPI(res.data.data.pengajuan))
    // dispath(setNotifOrderRevisi(res.data.data.revisi))
    dispath(setNotifOrderReject(res.data.data.ditolak))
    // dispath(setNotifOrderSelesai(res.data.data.selesai))

    const dataNonSales = {status_notif: [5]}
    const resNon = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/order-submission/all?credentials=${credential}&regarding=PO002`,
      {
        params: dataNonSales,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    dispath(setNotifNonSales(resNon.data.data.total))

    const resAmand = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/order-submission/all?credentials=${credential}&is_amendment=true&is_amendment_notif=true`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    dispath(setNotifAmandemenOrder(resAmand.data.data))

    const resNego = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/notification/approvals?credentials=${credential}&role=customer_negotiation_admin`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    dispath(setNotifNego(resNego.data.data))
  }

  // Sales Anper
  const getNotifSalesAnper = async () => {
    // const res = await axios.get(
    //   `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sip_order?credentials=${credential}&status_notif=4`,
    //   {
    //     headers: {
    //       Authorization: `Bearer ${localStorage.getItem('token')}`,
    //       apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
    //       Accept: 'application/json',
    //       'Access-Control-Allow-Origin': '*',
    //     },
    //   }
    //   // `http://34.128.85.104/management/api/notification/approvals?credentials=${credential}&role=sales_anper`
    // )

    const resKontrak = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract?credentials=${credential}&status_notif=2`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )

    const resKontrakAmand = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract?credentials=${credential}&is_amendment_notif=true`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )

    const approval = await axios.get(
      process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT +
        '/sales-order?credentials=' +
        credential +
        '&status_notif=0',
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )

    const param = {status_notif: [1]}
    const resFin = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/findoc?credentials=${credential}`,
      {
        params: param,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )

    dispath(setNotifFindocFinance(resFin.data.data.total))

    // console.log(resKontrakAmand.data.data,'resKontrakAmand')

    dispath(setNotifContractSA(resKontrak.data.data))
    // dispath(setNotifSIPSA(res.data.data))
    dispath(setNotifAmandemenContract(resKontrakAmand.data.data))
    dispath(setNotifApprovalSA(approval.data.data))
    // dispath()
    // dispath(setNotifContractSA(res.data.data.contract))
    // dispath(setNotifSalesOrderSA(res.data.data.sales_order))

    /**
     * Request get natification data findoc approve, reject and revision
     */
    const baseUrl = process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT as string
    const endpoint = `${baseUrl}/findoc?credentials=${credential}`
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    }

    const statusNotif = [1, 99] // Dikirimkan(1), Ditolak(99)
    const findocResponse = await Promise.all(
      statusNotif.map(async (value) => {
        return await axios.get(`${endpoint}&status_notif[]=${value}`, {headers})
      })
    )

    const totalFindocSent = findocResponse[0].data.data.total as number
    const totalFindocReject = findocResponse[1].data.data.total as number

    dispath(setNotifFindocSent(totalFindocSent))
    dispath(setNotifFindocRej(totalFindocReject))
  }

  // Customer
  const getNotifCustomer = async () => {
    const data = {status_notif: [2, 90]}
    const resOD = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/order-submission/all?credentials=${credential}&regarding=PO001`,
      {
        params: data,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    // dispath(setNotifOrderCus(resOD.data.data.total))
    dispath(setNotifOrderRevisi(resOD.data.data.revisi))
    dispath(setNotifOrderReject(resOD.data.data.ditolak))
    // dispath(setNotifOrderSelesai(resOD.data.data.selesai))
    const dataNonSales = {status_notif: [5]}
    const resNon = await await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/order-submission/all?credentials=${credential}&regarding=PO002`,
      {
        params: dataNonSales,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    dispath(setNotifNonSales(resNon.data.data.total))
    // await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve('')
    //   }, 5000)
    // })
    const resSO = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sales-order?credentials=${credential}&status_notif=7`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    dispath(setNotifSalesOrder(resSO.data.data))
    // await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve('')
    //   }, 5000)
    // })
    const resCO = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/contract?credentials=${credential}&status_notif=9`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    dispath(setNotifContract(resCO.data.data))
    // await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve('')
    //   }, 5000)
    // })

    /** @deprecated  */
    const resFindoc = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/notification/approvals?credentials=${credential}&role=customer_findoc`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )

    /**
     * Request get natification data findoc approve, reject and revision
     */
    const baseUrl = process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT as string
    const endpoint = `${baseUrl}/findoc?credentials=${credential}`
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    }

    const statusNotif = [2, 99] // Revisi(2), Ditolak(99)
    const findocResponse = await Promise.all(
      statusNotif.map(async (value) => {
        return await axios.get(`${endpoint}&status_notif[]=${value}`, {headers})
      })
    )

    const totalFindocRevision = findocResponse[0].data.data.total as number
    const totalFindocReject = findocResponse[1].data.data.total as number

    dispath(setNotifFindocRev(totalFindocRevision))
    dispath(setNotifFindocRej(totalFindocReject))

    // await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve('')
    //   }, 5000)
    // })

    const resNego = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/notification/approvals?credentials=${credential}&role=customer_negotiation`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )
    dispath(setNotifNego(resNego.data.data))
    // await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve('')
    //   }, 5000)
    // })

    // const resSIP = await axios.get(
    //   `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sip_order?credentials=${credential}&status_notif=8`
    // )
    // dispath(setNotifSIP(resSIP.data.data))
  }

  //Finance
  const getNotifFinance = async () => {
    const data = {status_notif: [1, 4]}
    const res = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/findoc?credentials=${credential}`,
      {
        params: data,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )

    dispath(setNotifFindocFinance(res.data.data.total))

    /**
     * Request get natification data findoc approve, reject and revision
     */
    const baseUrl = process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT as string
    const endpoint = `${baseUrl}/findoc?credentials=${credential}`
    const headers = {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
      Accept: 'application/json',
      'Access-Control-Allow-Origin': '*',
    }

    const statusNotif = [1, 4, 99] // Dikirimkan(1), Revisi(4) Ditolak(99)
    const findocResponse = await Promise.all(
      statusNotif.map(async (value) => {
        return await axios.get(`${endpoint}&status_notif[]=${value}`, {headers})
      })
    )

    const totalFindocSent = findocResponse[0].data.data.total as number
    const totalFindocRevisi = findocResponse[1].data.data.total as number
    const totalFindocReject = findocResponse[2].data.data.total as number

    dispath(setNotifFindocSent(totalFindocSent))
    dispath(setNotifFindocRev(totalFindocRevisi))
    dispath(setNotifFindocRej(totalFindocReject))
  }

  // SI
  const getNotifSI = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/sip_order`,
      {
        params: {
          credentials: credential,
          flag_notif: JSON.stringify([1,3])
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )

    dispath(setNotifSIProcess(res.data.data.proses_sip))
    dispath(setNotifSIAmend(res.data.data.amendment))
    dispath(setNotifSITotal(res.data.data.total))
  }

  useEffect(() => {
    if (credential == 'null' || credential == null) {
      checkToken(token?.replace(/['"]+/g, '')).then((res) => {
        localStorage.setItem('credential', res.data.credential)
        const test = atob(res.data.credential)
        const temp = JSON.parse(test)
        localStorage.setItem('accesses', JSON.stringify(res.data.accesses))
        if (temp.role_flag == null)
          localStorage.setItem(
            'username',
            temp.customer?.title != null
              ? temp.customer?.title + ' ' + temp.customer?.name
              : temp.customer?.name
          )
        else localStorage.setItem('username', temp.name)
        localStorage.setItem('credential-decoded', test)
        setCredential(res.data.credential)
      })
      return
    }

    // if (role === 'admin') {
    // getNotifAdmin()
    // console.log(role)
    // }
    if (role === 'null') {
      getNotifCustomer()
      // console.log(role)
    } else if (role === 'otorisator') {
      getNotifOtorisator()
      // console.log(role)
    } else if (role === 'salesAnper') {
      getNotifSalesAnper()
      getNotifSI()
      // console.log(role)
    } else if (role === 'salesAdmin') {
      getNotifOrderSalesAdmin()
    } else if (role === 'finance') {
      getNotifFinance()
    }

    const closeInterval = setInterval(() => {
      // if (role === 'admin') {
      //   getNotifAdmin()
      // }
      if (role === 'null') {
        getNotifCustomer()
      } else if (role === 'otorisator') {
        getNotifOtorisator()
      } else if (role === 'salesAnper') {
        getNotifSalesAnper()
        getNotifSI()
      } else if (role === 'salesAdmin') {
        getNotifOrderSalesAdmin()
      } else if (role === 'finance') {
        getNotifFinance()
      }
    }, 1000 * 60)

    return () => {
      clearInterval(closeInterval)
    }
  }, [credential, getNotif])
  return <>{children}</>
}
